import { debounce as debounceFn } from 'js/lib/general-utils'
import 'js/lib/history' // imported to support listening to history changes
import { on } from 'js/lib/events'

export function useListener(listenerAst) {
  const listeners = walkAst(listenerAst)

  function onChange(callback) {
    const cleanupFns = listeners.map(listener => {
      const { eventName, selector, opts } = listener

      if (opts.debounce) callback = debounceFn(callback, opts.debounce)

      return on(eventName, selector, (event, matchedElement) => {
        if (opts.prevent_default) event.preventDefault()
        callback(event, matchedElement)
      })
    })

    return () => cleanupFns.forEach(fn => fn())
  }

  return {
    onChange,
    listeners,
  }
}

function walkAst(ast) {
  const [name] = ast
  if (name === 'listeners') return walkAskForList(ast)
  if (name === 'listener') return [walkAskForSingle(ast)]
}

function walkAskForList(ast) {
  const [name, listeners] = ast
  if (name !== 'listeners') throw new Error('Cannot parse listener')
  return listeners.map(walkAskForSingle)
}

function walkAskForSingle(ast) {
  const [name, eventName, selector, rawOpts] = ast
  if (name !== 'listener') throw new Error('Cannot parse listener')
  const opts = Object.fromEntries(new Map(rawOpts))
  return { eventName, selector, opts }
}
